export default __webpack_public_path__ + "static/home-2-8a46c73dedbcfbd13fafa4c674cc3f1e.webp";